import { render } from "./addPlayers.vue?vue&type=template&id=7c208e93&scoped=true"
import script from "./addPlayers.vue?vue&type=script&lang=js"
export * from "./addPlayers.vue?vue&type=script&lang=js"

import "./addPlayers.vue?vue&type=style&index=0&id=7c208e93&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c208e93"]])

export default __exports__